import { api } from "../api";

/**
 * findAllData - Function that finds on database all data to dashboard
 * /dashboard/{managerId}?customerId={}
 * method GET  
 * @async-function
 */
const findAllData = async (token: string, managerId: number, customerId: number | null = null) => {
    const response = await api.get(
        `/dashboard/${managerId}${customerId ? `?customerId=${customerId}` : ""}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllData;